// ABOUTME: Card component for displaying external channels in mobile/phone view
// ABOUTME: Shows channel info including name, type, status, and created date

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import ShLabel from "../../../theme/label/ShLabel";
import { ReactComponent as PredikoLogo } from '../../../../styles/svg/prediko.svg';
import { ReactComponent as ReturnlessLogo } from '../../../../styles/svg/returnless.svg';
import { ReactComponent as AmpereLogo } from '../../../../styles/svg/ampere.svg';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import { useTranslation } from "react-i18next";
import PublicIcon from '@mui/icons-material/Public';

export const WarehouseExternalChannelCard = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const friendlyChannelType = (type) => {
        switch (type) {
            case "prediko":
                return "Prediko";
            case "returnless":
                return "Returnless";
            case "zonos":
                return "Zonos";
            case "ampere":
                return "Ampère";
            default:
                return t('unknown');
        }
    };

    const getChannelLogo = (type) => {
        switch (type) {
            case "prediko":
                return <PredikoLogo style={{ width: 30, height: 30 }} />;
            case "returnless":
                return <ReturnlessLogo style={{ width: 30, height: 30 }} />;
            case "zonos":
                return <PublicIcon sx={{ width: 30, height: 30 }} />;
            case "ampere":
                return <AmpereLogo style={{ width: 30, height: 30 }} />;
            default:
                return <IntegrationInstructionsIcon sx={{ fontSize: 30, color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] }} />;
        }
    };

    const labelColor = props.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey";
    const date = new Date(props.createdAt).toLocaleDateString(i18n.language);

    return (
        <Box
            onClick={props.onClick}
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                padding: 2,
                width: 1,
                borderRadius: "8px",
                backgroundColor: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50],
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                }
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
                {getChannelLogo(props.channel_type)}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                    <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>
                        {props.description}
                    </Text>
                    <Text light small>
                        {friendlyChannelType(props.channel_type)} · {date}
                    </Text>
                </Box>
            </Box>
            <ShLabel size={32} palette="normal" variant={labelColor}>
                {t(props.state)}
            </ShLabel>
        </Box>
    );
};

export const RelationExternalChannelCard = WarehouseExternalChannelCard;
